exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".admin-coming-home-status-label{color:white;opacity:.6;font-style:italic}\n", ""]);

// exports
